/**
 * @generated SignedSource<<1c8af4b56960eabdf3f111dd482dc28d>>
 * @relayHash 274839727125cd4cfb5df2a953e848c2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3db0b67ffa237976e7428b91fe614d9b7615cc5ab3229022bc0b7cc4be64fa31

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ProjectDirectoryLayoutQuery } from './ProjectDirectoryLayoutQuery.graphql';

import isAllowingEndUsersToAccessCustomTemplates_provider from '@atlassian/jira-relay-provider/src/jira-custom-template-allow-end-users-to-create-custom-templates.relayprovider';

const node: PreloadableConcreteRequest<ProjectDirectoryLayoutQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3db0b67ffa237976e7428b91fe614d9b7615cc5ab3229022bc0b7cc4be64fa31",
    "metadata": {},
    "name": "ProjectDirectoryLayoutQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider
    }
  }
};

export default node;
